<template>
  <div class="root">
    <div class="form">
      <el-form :model="formData" label-position="right" label-width="80px">
        <div class="form-item-row">
          <el-form-item prop="dispatchNumber" label="发车批次">
            <el-input v-model="formData.dispatchNumber" disabled></el-input>
          </el-form-item>
          <el-form-item prop="carNum" label="车牌号">
            <el-input v-model="formData.carNumber" disabled></el-input>
          </el-form-item>
          <el-form-item prop="driver" label="司机">
            <el-input v-model="formData.driverName" disabled></el-input>
          </el-form-item>
        </div>
        <div class="form-item-row">
          <el-form-item prop="contractNumber" label="合同编号">
            <el-input v-model="formData.contractNumber" disabled></el-input>
          </el-form-item>
          <el-form-item prop="contactsPhone" label="联系电话">
            <el-input v-model="formData.contactsPhone" disabled></el-input>
          </el-form-item>
          <el-form-item prop="planDepartureTime" label="发车时间">
            <el-date-picker
              v-model="formData.planDepartureTime"
              type="datetime"
              placeholder="选择发车时间"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-row">
          <el-form-item prop="operationTime" label="发生时间">
            <el-date-picker
              v-model="formData.operationTime"
              type="datetime"
              placeholder="选择发生时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="isShow" label-width="10px">
            <el-checkbox
              v-model="formData.isShow"
              :true-label="1"
              :false-label="0"
              >显示到运单轨迹</el-checkbox
            >
          </el-form-item>
          <el-form-item></el-form-item>
        </div>
        <el-form-item prop="content" label="跟踪内容">
          <el-input
            type="textarea"
            v-model="formData.content"
            rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="glo_btnItems glo_bgcMainColor"
            size="small"
            @click="save"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <!-- 表格 -->
      <mytable
        :maxHeight="tableHeigth"
        :tableData="tableData"
        :myTableHeard="myTableHeard"
        :isShowOperate="false"
        :isselection="false"
        :isShowMoreOperate="false"
        :Operatewidth="0"
        :showFilter="false"
      ></mytable>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageStart"
        :page-size="pageTotal"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageCount"
        hide-on-single-page
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import mytable from "@/components/table/table.vue";
export default {
  mixins: [tableListNew],
  components: {
    mytable,
  },
  props: {
    dispatchInfo: {},
  },
  data() {
    return {
      formData: {
        operationTime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        isShow:0,
        content:''
      },
      pageGroupName: "OnwayTrace", //  页面标识
      reportFiledsNumber: "admin_kefu_list", // 动态 条件、表头
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: 10, //  一页几条
    };
  },
  mounted() {
    Object.assign(this.formData, this, this.dispatchInfo);
    this.fetchInfo();
  },
  methods: {
    fetchInfo() {
      this.getData({
        documentStatus: "bill_tms_dispatch_v3:document_status",
        documentNumber: this.formData.dispatchNumber,
      });
    },
    save() {
      const params = {
        dispatchId : this.dispatchInfo.dispatchId,
        content: this.formData.content,
        isShow: this.formData.isShow,
        operationTime: this.formData.operationTime,
      };
      this.$API.addBillKfTrackRecordV5(params).then((res) => {
        this.$message.success("保存成功");
        this.fetchInfo();
        this.formData.isShow = 0;
        this.formData.content = "";
      }).catch(err=>{
        this.$message.error("保存失败")
      })
    },
  },
};
</script>

<style lang="less" scoped>
.root {
  height: calc(100vh - 260px);
  min-height: 500px;
  .form-item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-form-item {
      flex: 1;
      .el-input {
        width: 100%;
      }
    }
  }
}
</style>